var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSettingsSideMenuIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  fill: "none",
  viewBox: "0 0 17 17",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#49475A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3,
  d: "M8.5 10.546a2.046 2.046 0 1 0 0-4.092 2.046 2.046 0 0 0 0 4.092"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#49475A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3,
  d: "M13.546 10.546a1.125 1.125 0 0 0 .225 1.24l.04.041a1.364 1.364 0 1 1-1.93 1.93l-.04-.041a1.125 1.125 0 0 0-1.241-.225 1.13 1.13 0 0 0-.682 1.03v.115a1.364 1.364 0 0 1-2.727 0v-.061a1.125 1.125 0 0 0-.736-1.03 1.125 1.125 0 0 0-1.241.226l-.041.04a1.365 1.365 0 1 1-1.93-1.93l.041-.04A1.125 1.125 0 0 0 3.51 10.6a1.13 1.13 0 0 0-1.03-.682h-.115a1.364 1.364 0 0 1 0-2.727h.061a1.125 1.125 0 0 0 1.03-.736 1.125 1.125 0 0 0-.225-1.241l-.041-.041a1.364 1.364 0 1 1 1.93-1.93l.04.041A1.125 1.125 0 0 0 6.4 3.51h.055a1.13 1.13 0 0 0 .681-1.03v-.115a1.364 1.364 0 0 1 2.728 0v.061a1.13 1.13 0 0 0 .681 1.03 1.125 1.125 0 0 0 1.241-.225l.041-.041a1.363 1.363 0 0 1 2.226.442 1.36 1.36 0 0 1-.296 1.487l-.041.041A1.125 1.125 0 0 0 13.49 6.4v.055a1.12 1.12 0 0 0 1.03.681h.115a1.364 1.364 0 0 1 0 2.728h-.061a1.13 1.13 0 0 0-1.03.681"
})));
export { SvgSettingsSideMenuIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/settings-side-menu-icon.svg";